import * as Types from '../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EditCarModal_carFragment = { __typename?: 'Car', createdAt: any, id: string, year?: number | null, make?: string | null, model?: string | null, colour?: string | null, vin?: string | null, licensePlate?: string | null, trim?: string | null };

export type UpdateCarMutationVariables = Types.Exact<{
  car: Types.UpdateCarInput;
}>;


export type UpdateCarMutation = { __typename?: 'Mutation', updateCar: { __typename?: 'Car', createdAt: any, id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null, vin?: string | null, licensePlate?: string | null, trim?: string | null } };

export const EditCarModal_carFragmentDoc = gql`
    fragment EditCarModal_car on Car {
  createdAt
  id
  year
  make
  model
  colour
  vin
  licensePlate
  trim
}
    `;
export const UpdateCarDocument = gql`
    mutation UpdateCar($car: UpdateCarInput!) {
  updateCar(car: $car) {
    createdAt
    id
    make
    model
    year
    colour
    vin
    licensePlate
    trim
  }
}
    `;
export type UpdateCarMutationFn = Apollo.MutationFunction<UpdateCarMutation, UpdateCarMutationVariables>;

/**
 * __useUpdateCarMutation__
 *
 * To run a mutation, you first call `useUpdateCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarMutation, { data, loading, error }] = useUpdateCarMutation({
 *   variables: {
 *      car: // value for 'car'
 *   },
 * });
 */
export function useUpdateCarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarMutation, UpdateCarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarMutation, UpdateCarMutationVariables>(UpdateCarDocument, options);
      }
export type UpdateCarMutationHookResult = ReturnType<typeof useUpdateCarMutation>;
export type UpdateCarMutationResult = Apollo.MutationResult<UpdateCarMutation>;
export type UpdateCarMutationOptions = Apollo.BaseMutationOptions<UpdateCarMutation, UpdateCarMutationVariables>;